<template>
  <div class="mod-purchase-supplier">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="pageIndex = 1; getDataList()">
      <el-form-item label="供应商编码">
        <el-input v-model="dataForm.supplierCode" placeholder="供应商编码" size="small" clearable />
      </el-form-item>
      <el-form-item label="供应商名称">
        <el-input v-model="dataForm.supplierName" placeholder="供应商名称" size="small" clearable />
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('purchase:supplier:list')" type="primary" size="small" @click="pageIndex = 1; getDataList()">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('purchase:supplier:save')" type="primary" size="small" @click="addOrUpdateHandle()">新增</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="dataList" border v-loading="dataListLoading" :header-cell-style="{ background: '#f5f7fa', color: '#606266' }">
      <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
      <el-table-column prop="supplierCode" label="供应商编码" width="130" header-align="center" align="left" />
      <el-table-column prop="supplierName" label="供应商名称" min-width="160" header-align="center" align="left">
        <template slot-scope="scope">
          <a v-if="isAuth('purchase:supplier:info')" class="code-link" @click="addOrUpdateHandle(scope.row.supplierId, true)">{{ scope.row.supplierName }}</a>
          <span v-else>{{ scope.row.supplierName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="contactPerson" label="联系人" width="100" header-align="center" align="left" />
      <el-table-column prop="phone" label="联系电话" width="130" header-align="center" align="left" />
      <el-table-column prop="address" label="地址" min-width="160" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="isenabled" label="启用" width="80" header-align="center" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.isenabled === '0'" type="success" size="small">是</el-tag>
          <el-tag v-else type="info" size="small">否</el-tag>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="val => { pageSize = val; pageIndex = 1; getDataList() }"
      @current-change="val => { pageIndex = val; getDataList() }"
      :current-page="pageIndex"
      :page-sizes="[20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper"
    />

    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList" />
  </div>
</template>

<script>
import AddOrUpdate from './supplier-add-or-update'
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'

export default {
  name: 'ErpSupplier',
  components: { AddOrUpdate },
  data() {
    return {
      dataForm: { supplierCode: '', supplierName: '' },
      dataList: [],
      pageIndex: 1,
      pageSize: 20,
      totalPage: 0,
      dataListLoading: false,
      addOrUpdateVisible: false,
      permCodes: []
    }
  },
  created() { this.loadPerms(); this.getDataList() },
  activated() { this.getDataList() },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      const role = String(user.roleCode || '')
      if (role === 'TENANT_ADMIN' || role === 'PLATFORM_ADMIN' || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    getDataList() {
      this.dataListLoading = true
      request.post('/purchase/supplier/list', {
        currentPage: this.pageIndex,
        pageSize: this.pageSize,
        code: this.dataForm.supplierCode,
        partnerName: this.dataForm.supplierName
      }).then(res => {
        const body = res.data || {}
        this.dataList = body.list || []
        this.totalPage = body.totalCount || 0
      }).catch(() => {}).finally(() => { this.dataListLoading = false })
    },
    addOrUpdateHandle(id, readonly) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => this.$refs.addOrUpdate.init(id, readonly))
    },
    open(id, readonly) { this.addOrUpdateHandle(id, !!readonly) }
  }
}
</script>

<style scoped>
.code-link { cursor: pointer; color: #348adb; }
</style>
